module.exports = __webpack_public_path__ + "img/b300x300.32c08823.jpg";